export { default as Img200 } from './processed/200/GUNPOWDER-Layered.jpg';
export { default as Img400 } from './processed/400/GUNPOWDER-Layered.jpg';
export { default as Imgthumb } from './processed/thumb/GUNPOWDER-Layered.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/GUNPOWDER-Layered.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/GUNPOWDER-Layered.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      167,
      118,
      76
    ],
    "_population": 563,
    "_hsl": [
      0.07692307692307694,
      0.37448559670781895,
      0.4764705882352941
    ]
  },
  "LightVibrant": {
    "_rgb": [
      216,
      193,
      166
    ],
    "_population": 62,
    "_hsl": [
      0.08999999999999997,
      0.39062500000000006,
      0.7490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      88,
      54,
      36
    ],
    "_population": 395,
    "_hsl": [
      0.05769230769230769,
      0.41935483870967744,
      0.24313725490196078
    ]
  },
  "Muted": {
    "_rgb": [
      173,
      131,
      104
    ],
    "_population": 216,
    "_hsl": [
      0.0652173913043478,
      0.29613733905579404,
      0.5431372549019609
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      172,
      156
    ],
    "_population": 1,
    "_hsl": [
      0.05555555555555555,
      0.32000000000000006,
      0.7058823529411765
    ]
  },
  "DarkMuted": {
    "_rgb": [
      91,
      64,
      52
    ],
    "_population": 1270,
    "_hsl": [
      0.05128205128205127,
      0.27272727272727276,
      0.2803921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/GUNPOWDER-Layered.js